import { useNavigation } from "@react-navigation/native";
import { useCallback } from "react";

import { Banner, CalloutRefresh, RegisterForm } from "../components";
import { useCities, useCountries } from "../services";
import { LoadingScreen } from "./loading";

export function RegisterScreen() {
  // Data
  const {
    data: cities,
    isLoading: isCitiesLoading,
    refetch: refreshCities,
  } = useCities();
  const {
    data: countries,
    isLoading: isCountriesLoading,
    refetch: refreshCountries,
  } = useCountries();

  // Vars
  const navigation = useNavigation();

  // Methods
  const refresh = useCallback(() => {
    refreshCities();
    refreshCountries();
  }, [refreshCities, refreshCountries]);

  const goToLoginOtp = useCallback(
    (phone: string) => {
      navigation.navigate("LoginOtp", { phone });
    },
    [navigation]
  );

  // Render
  if (isCitiesLoading || isCountriesLoading) {
    return <LoadingScreen />;
  }

  if (!cities || !countries) {
    return <CalloutRefresh onRefresh={refresh} />;
  }

  return (
    <>
      <Banner message="We are unable to send SMS to +65 (Singapore) / +61 (Australia) / +971 (UAE) phone numbers.|Please message contact@smooci.com for help." />
      <RegisterForm {...{ cities, countries }} onSuccess={goToLoginOtp} />
    </>
  );
}
